"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EMAIL_TYPES = void 0;
exports.EMAIL_TYPES = {
    START_REGISTRATION: {
        type: 'start-registration',
        detail: 'Start registration email sent to employee',
        type_to_show: 'Recordatorio contraseña',
    },
    PENDING_REGISTRATION: {
        type: 'pending-registration',
        detail: 'Pending registration email sent to employee',
        type_to_show: 'Continuar proceso',
    },
    INVITATION_REGISTRATION: {
        type: 'invitation-registration',
        detail: 'Invitation registration email sent to employee',
        type_to_show: 'Invitación a registrarse',
    },
    UPDATED_EMAIL_NOTIFICATION: {
        type: 'updated-email-notification',
        detail: 'Updated email notification sent to employee',
        type_to_show: 'Notificación de cambio de email',
    },
};
//# sourceMappingURL=email-types.js.map